<template>
  <div class='preViewWrap'>
    <div class='preView'>
      <el-button type="primary" v-print='printOption'>打印</el-button>
      <el-button type="info" @click="gotoBack">返回</el-button>
      <div id='print'>
        <div class='preViewItem' v-for='item in oilInfoList' :key='item.radarId'>
          <div class='preViewTitle'>{{item.wareName}}</div>
          <div class='preViewInfo'>
            <div class="preViewPart">
              <div>
                <div class='preViewpartName'>雷达高度</div>
                <div class='preViewpartValue'>{{item.wareHeight}}m</div>
              </div>
              <div>
                <div class='preViewpartName'>油罐体积</div>
                <div class='preViewpartValue'>{{item.wareVolume}}m³</div>
              </div>
            </div>
            <div class="preViewPart">
              <div>
                <div class='preViewpartName'>油罐高度</div>
                <div class='preViewpartValue'>{{item.height}}m</div>
              </div>
              <div>
                <div class='preViewpartName'>油&nbsp;&nbsp;量(%)</div>
                <div class='preViewpartValue'>{{item.percentage||item.percentage==0?item.percentage:'--'}}</div>
              </div>
            </div>
            <div class="preViewPart">
              <div>
                <div class='preViewpartName'>油位高</div>
                <div class='preViewpartValue'>{{item.bitHeight}}m</div>
              </div>
              <div>
                <div class='preViewpartName'>油密度</div>
                <div class='preViewpartValue'>{{item.density}}kg/m³</div>
              </div>
            </div>
            <div class="preViewPart" style='flex-grow:1'>
              <div class='preViewtempInfo'>平均温度(℃)</div>
              <div class='preViewtempInfoValue'>{{item.tempAve||item.tempAve==0?item.tempAve:'--'}}</div>
            </div>
            <div class="preViewPart" style='flex-grow:1'>
              <div class='preViewtempInfo'>最高温度(℃)</div>
              <div class='preViewtempInfoValue'>{{item.tempMax||item.tempMax==0?item.tempMax:'--'}}</div>
            </div>
            <div class="preViewPart" style='flex-grow:1'>
              <div class='preViewtempInfo' style='border-right:none'>最低温度(℃)</div>
              <div class='preViewtempInfoValue' style='border-right:none'>{{item.tempMin||item.tempMin==0?item.tempMin:'--'}}</div>
            </div>
          </div>
          <div class='preViewTempRowInfo'>
            <div class='preViewTempTitle'>
              <div>层</div>
              <div>温度(℃)</div>
            </div>
            <div v-for="(event,index) in item.temps" :key='index' class='preViewTempItem' v-if="item.temps.length>0">
              <div v-if='index==0' class='preViewTempItemWrap'>
                <div :class='index+1==item.temps.length?"preViewTempItemName":""'>罐温</div>
                <div :class='index+1==item.temps.length?"preViewTempItemValue":""'>{{event||event==0?event:'--'}}</div>
              </div>
              <div v-else class='preViewTempItemWrap'>
                <div :class='index+1==item.temps.length?"preViewTempItemName":""'>第{{index}}层</div>
                <div :class='index+1==item.temps.length?"preViewTempItemValue":""'>{{event||event==0?event:'--'}}</div>
              </div>
            </div>
            <div class='preViewTempItem' v-if="item.temps.length==0">
              <div class="preViewTempItemName"></div>
              <div class="preViewTempItemValue"></div>
            </div>
          </div>
          <div class="preViewCard">
            <div class="preViewCardInfo">
              <div class="preViewCardItem">
                <span>油脂品种</span>
                <span>{{item.foodFariety}}</span>
              </div>
              <div class="preViewCardItem">
                <span>油脂性质</span>
                <span style="border-right:none">{{item.foodType}}</span>
              </div>
            </div>
            <div class="preViewCardInfo">
              <div class="preViewCardItem">
                <span>油脂等级</span>
                <span>{{item.foodLevel}}</span>
              </div>
              <div class="preViewCardItem">
                <span>油脂产地</span>
                <span style="border-right:none">{{item.origin}}</span>
              </div>
            </div>
            <div class="preViewCardInfo">
              <div class="preViewCardItem">
                <span>采集时间</span>
                <span>{{item.currTime}}</span>
              </div>
              <div class="preViewCardItem">
                <span>保管员</span>
                <span style="border-right:none">{{item.custodian}}</span>
              </div>
            </div>
          </div>
          <div class="setTabTime">制表时间：{{dataTime}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  data(){
    return{
      oilInfoList:[],
      dataTime:'',
      printOption:{
        id:'print',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        popTitle: '油情信息'
      }
    }
  },
  created(){
    this.getOilInfoList()
  },
   beforeRouteLeave(to,from,next){
    to.meta.keepAlive = true
    next(0)
  },
  methods:{
    gotoBack(){
      this.$router.go(-1)
    },
    getOilInfoList(){
      let wareIds=this.$route.params.wareIds;
      axios.post('/system/radar/print',wareIds).then(res=>{
        this.oilInfoList=res.data.radarInfo;
        this.dataTime=res.data.dateTime;
      })
    }
  }
}
</script>

<style>
.preViewItem{
  border: 1px solid gray;
  margin: 10px 0;
  box-sizing: border-box;
  font-size: 12px
}
.preViewTitle{
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid gray;
  width: 100%;
  box-sizing: border-box;
  font-weight: 600
}
.preViewInfo{
  display: flex
}
.preViewPart{
  flex-grow: 2;
}
.preViewPart>div{
  border-right: 1px solid gray;
  border-bottom: 1px solid gray;
  height: 38px;
  line-height: 38px;
  display: flex;
  box-sizing: border-box
}
.preViewpartName{
  border-right: 1px solid gray;
  width: 80px;
  text-align: center;
  box-sizing: border-box
}
.preViewpartValue{
  flex-grow: 1;
  text-align: center
}
.preViewtempInfo{
  text-align: center;
  justify-content: center
}
.preViewtempInfoValue{
  text-align: center;
  justify-content: center
}
.preViewTempRowInfo{
  width: 100%;
  display: flex;
  height:76px;
}
.preViewTempRowInfo>div{
  height: 38px;
  line-height: 38px;
  box-sizing: border-box
}
.preViewTempTitle{
  flex-basis: 80px
}
.preViewTempTitle>div{
  border-right: 1px solid gray;
  border-bottom: 1px solid gray;
  text-align: center;
}
.preViewTempItem{
  flex-grow: 1;
}
.preViewTempItemWrap>div{
  text-align: center;
  border-right: 1px solid gray;
  border-bottom: 1px solid gray;
  height: 38px;
  line-height: 38px;
}
.preViewTempItemName,.preViewTempItemValue{
  border-right: none !important;
}
.preViewCardInfo{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid gray;
  box-sizing: border-box
}
.preViewCardInfo:last-child{
  border: none
}
.preViewCardItem{
  width: 50%;
  display: flex
}
.preViewCardItem span{
  display: inline-block;
  height: 38px;
  line-height: 38px;
  box-sizing: border-box;
  text-align: center;
  border-right: 1px solid gray;
}
.preViewCardItem span:first-child{
  flex-basis: 80px
}
.preViewCardItem span:last-child{
  flex-grow: 1
}
.setTabTime{
  line-height: 38px;
  height: 38px;
  border-top: 1px solid gray;
  text-align: end;
  padding-right: 10px;
  box-sizing: border-box
}
</style>
